import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOnboardingAdjusting = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 15,
	viewBox: "0 0 16 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 4.5L7.2 4.5M7.2 4.5C7.2 3.67157 6.48366 3 5.6 3C4.71634 3 4 3.67157 4 4.5M7.2 4.5C7.2 5.32843 6.48366 6 5.6 6C4.71634 6 4 5.32843 4 4.5M4 4.5L2 4.5M14 10.5L12 10.5M12 10.5C12 9.67157 11.2837 9 10.4 9C9.51634 9 8.8 9.67157 8.8 10.5M12 10.5C12 11.3284 11.2837 12 10.4 12C9.51634 12 8.8 11.3284 8.8 10.5M8.8 10.5L2 10.5",
		stroke: "#232323",
		strokeWidth: 1.41176,
		strokeLinecap: "round"
	})
});
export default SvgOnboardingAdjusting;
